/**
 * @generated SignedSource<<5f9f7abdfc7699e4e18280e0a1d5c9a8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PeopleFieldType = "DEPARTMENT" | "JOB_TITLE" | "LOCATION";
export type StaffDirectoryViewQuery$variables = {
  cloudId: string;
  first?: number | null;
  isBrowseAllScreen: boolean;
  isBrowsePeopleScreen: boolean;
  isSearchAllScreen: boolean;
  isSearchKudosScreen: boolean;
  isSearchPeopleScreen: boolean;
  isSearchTeamsScreen: boolean;
  kudosQuery: string;
  organisationId: string;
  peopleFieldType: PeopleFieldType;
  teamQuery: string;
  userQuery: string;
  workspaceId: string;
};
export type StaffDirectoryViewQuery$data = {
  readonly explainKudosTql?: {
    readonly explanation: string | null;
  } | null;
  readonly explainUserTql?: {
    readonly explanation: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"BrowseAllScreenQuery" | "BrowsePeopleFieldsScreenQuery" | "SearchAllScreen_data" | "SearchKudosScreen_data" | "SearchPeopleScreen_data" | "SearchTeamsScreen_data">;
};
export type StaffDirectoryViewQuery = {
  response: StaffDirectoryViewQuery$data;
  variables: StaffDirectoryViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isBrowseAllScreen"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isBrowsePeopleScreen"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSearchAllScreen"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSearchKudosScreen"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSearchPeopleScreen"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSearchTeamsScreen"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kudosQuery"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organisationId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "peopleFieldType"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamQuery"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userQuery"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v14 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "userQuery"
},
v15 = [
  {
    "kind": "ScalarField",
    "name": "explanation"
  }
],
v16 = {
  "condition": "isSearchKudosScreen",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": "explainUserTql",
      "args": [
        {
          "kind": "Literal",
          "name": "entity",
          "value": "PERSON"
        },
        (v14/*: any*/)
      ],
      "concreteType": "TQLExplanation",
      "kind": "LinkedField",
      "name": "explainTql",
      "plural": false,
      "selections": (v15/*: any*/)
    }
  ]
},
v17 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "kudosQuery"
},
v18 = {
  "alias": "explainKudosTql",
  "args": [
    {
      "kind": "Literal",
      "name": "entity",
      "value": "KUDOS"
    },
    (v17/*: any*/)
  ],
  "concreteType": "TQLExplanation",
  "kind": "LinkedField",
  "name": "explainTql",
  "plural": false,
  "selections": (v15/*: any*/)
},
v19 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v20 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v21 = {
  "kind": "Variable",
  "name": "organisationId",
  "variableName": "organisationId"
},
v22 = {
  "kind": "Variable",
  "name": "query",
  "variableName": "userQuery"
},
v23 = {
  "kind": "Variable",
  "name": "query",
  "variableName": "teamQuery"
},
v24 = {
  "kind": "Literal",
  "name": "first",
  "value": 4
},
v25 = {
  "kind": "Variable",
  "name": "workspaceId",
  "variableName": "workspaceId"
},
v26 = {
  "kind": "Variable",
  "name": "peopleFieldType",
  "variableName": "peopleFieldType"
},
v27 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  },
  (v17/*: any*/),
  (v25/*: any*/)
],
v28 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v29 = {
  "kind": "ScalarField",
  "name": "ari"
},
v30 = {
  "kind": "ScalarField",
  "name": "description"
},
v31 = {
  "kind": "ScalarField",
  "name": "imageUrl"
},
v32 = {
  "kind": "ScalarField",
  "name": "stillImageUrl"
},
v33 = {
  "kind": "ScalarField",
  "name": "type"
},
v34 = {
  "kind": "ScalarField",
  "name": "bgTheme"
},
v35 = {
  "kind": "ScalarField",
  "name": "name"
},
v36 = {
  "kind": "ScalarField",
  "name": "picture"
},
v37 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v38 = {
  "kind": "ScalarField",
  "name": "id"
},
v39 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "giver",
  "plural": false,
  "selections": [
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v35/*: any*/),
        (v36/*: any*/),
        (v37/*: any*/)
      ]
    },
    (v38/*: any*/)
  ]
},
v40 = {
  "kind": "ScalarField",
  "name": "teamId"
},
v41 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "KudosRecipientConnection",
  "kind": "LinkedField",
  "name": "recipients",
  "plural": false,
  "selections": [
    {
      "concreteType": "KudosRecipientEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "KudosRecipient",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "recipient",
              "plural": false,
              "selections": [
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    (v37/*: any*/),
                    (v35/*: any*/),
                    (v36/*: any*/)
                  ]
                },
                (v38/*: any*/)
              ]
            },
            {
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "team",
              "plural": false,
              "selections": [
                (v35/*: any*/),
                (v40/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "avatarUrl"
                },
                (v38/*: any*/)
              ]
            },
            (v38/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "recipients(first:1)"
},
v42 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v43 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v44 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v45 = [
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v14/*: any*/)
],
v46 = {
  "kind": "ScalarField",
  "name": "account_id"
},
v47 = {
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "MEDIUM"
    }
  ],
  "concreteType": "HighResolutionProfilePicture",
  "kind": "LinkedField",
  "name": "highResolutionProfilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "storageKey": "highResolutionProfilePicture(size:\"MEDIUM\")"
},
v48 = {
  "kind": "ScalarField",
  "name": "job_title"
},
v49 = {
  "concreteType": "ReportCounts",
  "kind": "LinkedField",
  "name": "reportCounts",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "directReports"
    }
  ]
},
v50 = {
  "kind": "ScalarField",
  "name": "location"
},
v51 = {
  "kind": "ScalarField",
  "name": "zoneinfo"
},
v52 = {
  "concreteType": "TeamConnection",
  "kind": "LinkedField",
  "name": "teams",
  "plural": false,
  "selections": [
    {
      "concreteType": "TeamEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v35/*: any*/),
            (v40/*: any*/),
            (v38/*: any*/)
          ]
        }
      ]
    }
  ]
},
v53 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "teamQuery"
},
v54 = [
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v53/*: any*/)
],
v55 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v56 = {
  "kind": "ScalarField",
  "name": "isVerified"
},
v57 = {
  "kind": "ScalarField",
  "name": "smallAvatarImageUrl"
},
v58 = {
  "kind": "ScalarField",
  "name": "largeAvatarImageUrl"
},
v59 = {
  "kind": "ScalarField",
  "name": "count"
},
v60 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    (v35/*: any*/),
    (v36/*: any*/)
  ]
},
v61 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v62 = {
  "concreteType": "TeamMemberConnection",
  "kind": "LinkedField",
  "name": "members",
  "plural": false,
  "selections": [
    (v59/*: any*/),
    {
      "concreteType": "TeamMemberEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TeamMember",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v60/*: any*/),
            (v61/*: any*/)
          ]
        }
      ]
    }
  ]
},
v63 = [
  "q",
  "organisationId",
  "cloudId"
],
v64 = {
  "concreteType": "PeopleFieldAggregate",
  "kind": "LinkedField",
  "name": "results",
  "plural": true,
  "selections": [
    (v35/*: any*/),
    {
      "kind": "ScalarField",
      "name": "imageDirectoryUrl"
    }
  ]
},
v65 = [
  (v64/*: any*/),
  {
    "concreteType": "PeopleFieldAggregateError",
    "kind": "LinkedField",
    "name": "errors",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "message"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StaffDirectoryViewQuery",
    "selections": [
      (v16/*: any*/),
      {
        "condition": "isSearchKudosScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v18/*: any*/)
        ]
      },
      {
        "args": [
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "kind": "Variable",
            "name": "isSearchAllScreen",
            "variableName": "isSearchAllScreen"
          },
          (v21/*: any*/),
          {
            "kind": "Variable",
            "name": "teamQuery",
            "variableName": "teamQuery"
          },
          {
            "kind": "Variable",
            "name": "userQuery",
            "variableName": "userQuery"
          }
        ],
        "kind": "FragmentSpread",
        "name": "SearchAllScreen_data"
      },
      {
        "args": [
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "kind": "Variable",
            "name": "isSearchPeopleScreen",
            "variableName": "isSearchPeopleScreen"
          },
          (v21/*: any*/),
          (v22/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SearchPeopleScreen_data"
      },
      {
        "args": [
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "kind": "Variable",
            "name": "isSearchTeamsScreen",
            "variableName": "isSearchTeamsScreen"
          },
          (v21/*: any*/),
          (v23/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SearchTeamsScreen_data"
      },
      {
        "condition": "isBrowseAllScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v19/*: any*/),
              (v24/*: any*/),
              {
                "kind": "Literal",
                "name": "kudosFirst",
                "value": 5
              },
              {
                "kind": "Variable",
                "name": "kudosQuery",
                "variableName": "kudosQuery"
              },
              (v21/*: any*/),
              (v23/*: any*/),
              (v25/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "BrowseAllScreenQuery"
          }
        ]
      },
      {
        "condition": "isBrowsePeopleScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v26/*: any*/),
              (v22/*: any*/),
              (v25/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "BrowsePeopleFieldsScreenQuery"
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "isSearchKudosScreen",
            "variableName": "isSearchKudosScreen"
          },
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "kudosQuery"
          },
          (v25/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SearchKudosScreen_data"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v11/*: any*/),
      (v12/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v9/*: any*/),
      (v13/*: any*/),
      (v0/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "StaffDirectoryViewQuery",
    "selections": [
      (v16/*: any*/),
      {
        "condition": "isSearchKudosScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v18/*: any*/),
          {
            "args": (v27/*: any*/),
            "concreteType": "KudosConnection",
            "kind": "LinkedField",
            "name": "kudosTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "KudosEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Kudos",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v39/*: any*/),
                      (v41/*: any*/),
                      (v38/*: any*/),
                      (v42/*: any*/)
                    ]
                  },
                  (v43/*: any*/)
                ]
              },
              (v44/*: any*/)
            ]
          },
          {
            "args": (v27/*: any*/),
            "filters": [
              "q",
              "workspaceId"
            ],
            "handle": "connection",
            "key": "SearchKudosScreen_kudosTql",
            "kind": "LinkedHandle",
            "name": "kudosTql"
          }
        ]
      },
      {
        "condition": "isSearchAllScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v45/*: any*/),
            "concreteType": "CpusSearchUserConnection",
            "kind": "LinkedField",
            "name": "peopleTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "CpusSearchUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "CpusSearchUser",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v46/*: any*/),
                      (v35/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v52/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "searchTeams",
            "args": (v54/*: any*/),
            "concreteType": "TeamSearchResponseConnection",
            "kind": "LinkedField",
            "name": "teamsTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "TeamSearchResponseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamSearchResponse",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      (v30/*: any*/),
                      (v55/*: any*/),
                      (v56/*: any*/),
                      (v57/*: any*/),
                      (v58/*: any*/),
                      (v62/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isSearchPeopleScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v45/*: any*/),
            "concreteType": "CpusSearchUserConnection",
            "kind": "LinkedField",
            "name": "peopleTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "CpusSearchUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "CpusSearchUser",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v46/*: any*/),
                      (v35/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v52/*: any*/),
                      (v42/*: any*/)
                    ]
                  },
                  (v43/*: any*/)
                ]
              },
              (v44/*: any*/)
            ]
          },
          {
            "args": (v45/*: any*/),
            "filters": (v63/*: any*/),
            "handle": "connection",
            "key": "SearchPeopleScreen_peopleTql",
            "kind": "LinkedHandle",
            "name": "peopleTql"
          }
        ]
      },
      {
        "condition": "isSearchTeamsScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "searchTeams",
            "args": (v54/*: any*/),
            "concreteType": "TeamSearchResponseConnection",
            "kind": "LinkedField",
            "name": "teamsTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "TeamSearchResponseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamSearchResponse",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      (v30/*: any*/),
                      (v55/*: any*/),
                      (v56/*: any*/),
                      (v57/*: any*/),
                      (v58/*: any*/),
                      (v62/*: any*/),
                      (v42/*: any*/)
                    ]
                  },
                  (v43/*: any*/)
                ]
              },
              (v44/*: any*/)
            ]
          },
          {
            "alias": "searchTeams",
            "args": (v54/*: any*/),
            "filters": (v63/*: any*/),
            "handle": "connection",
            "key": "SearchTeamsScreen_searchTeams",
            "kind": "LinkedHandle",
            "name": "teamsTql"
          }
        ]
      },
      {
        "condition": "isBrowseAllScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "browseTeams",
            "args": [
              (v19/*: any*/),
              (v24/*: any*/),
              (v21/*: any*/),
              (v53/*: any*/),
              {
                "kind": "Literal",
                "name": "sort",
                "value": [
                  "NAME_ASC"
                ]
              }
            ],
            "concreteType": "TeamSearchResponseConnection",
            "kind": "LinkedField",
            "name": "teamsTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "TeamSearchResponseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamSearchResponse",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      (v55/*: any*/),
                      (v30/*: any*/),
                      (v56/*: any*/),
                      (v57/*: any*/),
                      {
                        "concreteType": "TeamMemberConnection",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": false,
                        "selections": [
                          (v59/*: any*/),
                          {
                            "concreteType": "TeamMemberEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TeamMember",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/),
                                  (v60/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "kudos",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 5
              },
              (v17/*: any*/),
              (v25/*: any*/)
            ],
            "concreteType": "KudosConnection",
            "kind": "LinkedField",
            "name": "kudosTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "KudosEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Kudos",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v39/*: any*/),
                      (v41/*: any*/),
                      (v38/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "department",
            "args": [
              (v24/*: any*/),
              {
                "kind": "Literal",
                "name": "peopleFieldType",
                "value": "DEPARTMENT"
              },
              (v25/*: any*/)
            ],
            "concreteType": "PeopleFieldAggregateResponse",
            "kind": "LinkedField",
            "name": "peopleFieldAggregates",
            "plural": false,
            "selections": (v65/*: any*/)
          },
          {
            "alias": "location",
            "args": [
              (v24/*: any*/),
              {
                "kind": "Literal",
                "name": "peopleFieldType",
                "value": "LOCATION"
              },
              (v25/*: any*/)
            ],
            "concreteType": "PeopleFieldAggregateResponse",
            "kind": "LinkedField",
            "name": "peopleFieldAggregates",
            "plural": false,
            "selections": (v65/*: any*/)
          },
          {
            "alias": "jobTitle",
            "args": [
              (v24/*: any*/),
              {
                "kind": "Literal",
                "name": "peopleFieldType",
                "value": "JOB_TITLE"
              },
              (v25/*: any*/)
            ],
            "concreteType": "PeopleFieldAggregateResponse",
            "kind": "LinkedField",
            "name": "peopleFieldAggregates",
            "plural": false,
            "selections": (v65/*: any*/)
          }
        ]
      },
      {
        "condition": "isBrowsePeopleScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v26/*: any*/),
              {
                "kind": "Variable",
                "name": "searchString",
                "variableName": "userQuery"
              },
              (v25/*: any*/)
            ],
            "concreteType": "PeopleFieldAggregateResponse",
            "kind": "LinkedField",
            "name": "peopleFieldAggregates",
            "plural": false,
            "selections": [
              (v64/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ba5de08c43bea2673feb33075a730b83",
    "id": null,
    "metadata": {},
    "name": "StaffDirectoryViewQuery",
    "operationKind": "query",
    "text": "query StaffDirectoryViewQuery(\n  $teamQuery: String!\n  $userQuery: String!\n  $kudosQuery: String!\n  $first: Int\n  $organisationId: String!\n  $workspaceId: ID!\n  $cloudId: String!\n  $peopleFieldType: PeopleFieldType!\n  $isSearchAllScreen: Boolean!\n  $isSearchPeopleScreen: Boolean!\n  $isSearchTeamsScreen: Boolean!\n  $isBrowseAllScreen: Boolean!\n  $isBrowsePeopleScreen: Boolean!\n  $isSearchKudosScreen: Boolean!\n) {\n  explainUserTql: explainTql(q: $userQuery, entity: PERSON) @skip(if: $isSearchKudosScreen) {\n    explanation\n  }\n  explainKudosTql: explainTql(q: $kudosQuery, entity: KUDOS) @include(if: $isSearchKudosScreen) {\n    explanation\n  }\n  ...SearchAllScreen_data_JbUE\n  ...SearchPeopleScreen_data_3UNIJZ\n  ...SearchTeamsScreen_data_3q3FiE\n  ...BrowseAllScreenQuery_3VSrS1 @include(if: $isBrowseAllScreen)\n  ...BrowsePeopleFieldsScreenQuery_3BLJ7V @include(if: $isBrowsePeopleScreen)\n  ...SearchKudosScreen_data_4d2Pna\n}\n\nfragment BrowseAllScreenQuery_3VSrS1 on Query {\n  ...BrowseTeamSection_Q9pCr\n  ...BrowseKudosSection_POC2h\n  ...BrowseDepartmentSection_1SRpYj\n  ...BrowseLocationSection_1SRpYj\n  ...BrowseJobTitleSection_1SRpYj\n}\n\nfragment BrowseDepartmentSection_1SRpYj on Query {\n  department: peopleFieldAggregates(workspaceId: $workspaceId, peopleFieldType: DEPARTMENT, first: 4) {\n    ...BrowsePeopleFieldSection\n  }\n}\n\nfragment BrowseJobTitleSection_1SRpYj on Query {\n  jobTitle: peopleFieldAggregates(workspaceId: $workspaceId, peopleFieldType: JOB_TITLE, first: 4) {\n    ...BrowsePeopleFieldSection\n  }\n}\n\nfragment BrowseKudosSection_POC2h on Query {\n  kudos: kudosTql(workspaceId: $workspaceId, q: $kudosQuery, first: 5) {\n    edges {\n      node {\n        ...KudosContent\n        id\n      }\n    }\n  }\n}\n\nfragment BrowseLocationSection_1SRpYj on Query {\n  location: peopleFieldAggregates(workspaceId: $workspaceId, peopleFieldType: LOCATION, first: 4) {\n    ...BrowsePeopleFieldSection\n  }\n}\n\nfragment BrowsePeopleFieldSection on PeopleFieldAggregateResponse {\n  results {\n    ...LocationCard\n    ...IllustrationCard\n  }\n  errors {\n    message\n  }\n}\n\nfragment BrowsePeopleFieldsScreenQuery_3BLJ7V on Query {\n  peopleFieldAggregates(searchString: $userQuery, workspaceId: $workspaceId, peopleFieldType: $peopleFieldType) {\n    results {\n      ...LocationCard\n      ...IllustrationCard\n    }\n  }\n}\n\nfragment BrowseTeamSection_Q9pCr on Query {\n  browseTeams: teamsTql(q: $teamQuery, first: 4, sort: [NAME_ASC], organisationId: $organisationId, cloudId: $cloudId) {\n    edges {\n      node {\n        ...TeamCard\n      }\n    }\n  }\n}\n\nfragment CardTeamsSection on CpusSearchUser {\n  teams {\n    edges {\n      node {\n        name\n        teamId\n        id\n      }\n    }\n  }\n}\n\nfragment IllustrationCard on PeopleFieldAggregate {\n  name\n  imageDirectoryUrl\n}\n\nfragment KudosContent on Kudos {\n  uuid\n  ari\n  description\n  imageUrl\n  stillImageUrl\n  type\n  bgTheme\n  giver {\n    pii {\n      name\n      picture\n      accountId\n    }\n    id\n  }\n  recipients(first: 1) {\n    edges {\n      node {\n        recipient {\n          pii {\n            accountId\n            name\n            picture\n          }\n          id\n        }\n        team {\n          name\n          teamId\n          avatarUrl\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment LocationCard on PeopleFieldAggregate {\n  name\n  imageDirectoryUrl\n}\n\nfragment PersonSearchResultCard on CpusSearchUser {\n  account_id\n  name\n  highResolutionProfilePicture(size: MEDIUM) {\n    url\n  }\n  job_title\n  reportCounts {\n    directReports\n  }\n  location\n  zoneinfo\n  ...CardTeamsSection\n}\n\nfragment SearchAllScreen_data_JbUE on Query {\n  peopleTql(q: $userQuery, organisationId: $organisationId, cloudId: $cloudId, first: $first) @include(if: $isSearchAllScreen) {\n    edges {\n      node {\n        account_id\n        ...PersonSearchResultCard\n      }\n    }\n  }\n  searchTeams: teamsTql(q: $teamQuery, organisationId: $organisationId, cloudId: $cloudId, first: $first) @include(if: $isSearchAllScreen) {\n    edges {\n      node {\n        id\n        ...TeamSearchResultCard\n      }\n    }\n  }\n}\n\nfragment SearchKudosScreen_data_4d2Pna on Query {\n  kudosTql(q: $kudosQuery, workspaceId: $workspaceId, first: 12) @include(if: $isSearchKudosScreen) {\n    edges {\n      node {\n        ...KudosContent\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SearchPeopleScreen_data_3UNIJZ on Query {\n  peopleTql(q: $userQuery, organisationId: $organisationId, cloudId: $cloudId, first: $first) @include(if: $isSearchPeopleScreen) {\n    edges {\n      node {\n        account_id\n        ...PersonSearchResultCard\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SearchTeamsScreen_data_3q3FiE on Query {\n  searchTeams: teamsTql(q: $teamQuery, organisationId: $organisationId, cloudId: $cloudId, first: $first) @include(if: $isSearchTeamsScreen) {\n    edges {\n      node {\n        id\n        ...TeamSearchResultCard\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TeamCard on TeamSearchResponse {\n  id\n  displayName\n  description\n  isVerified\n  smallAvatarImageUrl\n  members {\n    count\n    edges {\n      node {\n        aaid\n        pii {\n          name\n          picture\n        }\n      }\n    }\n  }\n}\n\nfragment TeamSearchAvatar on TeamSearchResponse {\n  id\n  displayName\n  isVerified\n  largeAvatarImageUrl\n}\n\nfragment TeamSearchResultCard on TeamSearchResponse {\n  id\n  description\n  displayName\n  isVerified\n  smallAvatarImageUrl\n  ...TeamSearchAvatar\n  members {\n    count\n    edges {\n      node {\n        pii {\n          name\n          picture\n        }\n        aaid\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "888e2530bf7413a51ed6a1572caff593";

export default node;
